import { GameVars } from "../GameVars";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { GameConstants } from "../GameConstants";
import { MatchResultState } from "./end-result/MatchResultState";
import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";

    export class CreditsCounterContainer extends Phaser.Group {

        private creditsLabel: Phaser.Text;
        private rays: Phaser.Image;
        private extraGoalsLabel: Phaser.Text;
        private goalsLabel: Phaser.Text;
        private extraGoalsCreditsLabel: Phaser.Text;
        private goalsCreditsLabel: Phaser.Text;
        private credits: number;

        constructor(game: Phaser.Game) {

            super(game, null, "credits-on-victory-container", false);

            this.y = 355;
            this.credits = GameVars.gameData.credits;

            const bottomRectangleWithRadius = new RectangleWithRadius(this.game, 20 , 0, GameConstants.GAME_WIDTH - 40, 205 , 40,
                "#2B3536", .5, RectangleWithRadius.BOTTOM_CONFIGURATION);
            this.add( bottomRectangleWithRadius );

            this.addInitialCredits();
            this.addGoalsLabels();
            this.addCoins();

            if (GameVars.playerGoals !== 0) {
                this.startCreditsAnimation();
            }
        }

        private addInitialCredits(): void {

            this.rays = new Phaser.Image( this.game, GameConstants.GAME_WIDTH / 2, 50, "texture_atlas_1", "rays");
            this.rays.anchor.set(.5);
            this.rays.scale.set(1.5);
            this.rays.blendMode = 3;
            this.rays.visible = false;
            this.add(this.rays);

            this.game.add.tween(this.rays)
                .to({angle: 360}, 6000,  Phaser.Easing.Linear.None, true)
                .loop();

            const creditsCartridgeImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 22 , "texture_atlas_5", "credits_cartridge" );
            creditsCartridgeImage.anchor.setTo(.5, 0);
            this.add(creditsCartridgeImage);

            const creditsString = GameVars.formatNumber(this.credits);

            this.creditsLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 30,
                creditsString, { font: "36px Ubuntu", fontWeight: "700", fill: "#FFD51B", align: "center"});
            this.creditsLabel.x -= this.creditsLabel.width / 2;
            this.add(this.creditsLabel);
        }

        private addGoalsLabels(): void {

            const goalsLabel_px = 625;
            const moneyLabel_px = 700;

            const goalsCreditsStyle =  { font: "32px Ubuntu", fontWeight: "700", fill: "#000000", align: "left"};

            if (GameVars.matchResult === GameConstants.VICTORY && ( GameVars.playerGoals !== GameVars.adversaryGoals )) {

                this.extraGoalsLabel = new Phaser.Text(this.game, goalsLabel_px, 85,
                    "extra goals: " + (GameVars.playerGoals  - GameVars.adversaryGoals) + "x " + GameConstants.CREDITS_EXTRA_GOALS + " =",
                    goalsCreditsStyle);

                this.extraGoalsLabel.visible = false;
                // para alinear las 2 etiquetas por el simbolo de igual
                this.extraGoalsLabel.x -= this.extraGoalsLabel.width;
                this.add(this.extraGoalsLabel);

                this.extraGoalsCreditsLabel = new Phaser.Text(this.game, moneyLabel_px, 85,
                    "" + (GameVars.playerGoals  - GameVars.adversaryGoals) * GameConstants.CREDITS_EXTRA_GOALS,
                    goalsCreditsStyle);

                this.extraGoalsCreditsLabel.visible = false;
                this.extraGoalsCreditsLabel.x -= this.extraGoalsCreditsLabel.width;
                this.add(this.extraGoalsCreditsLabel);

                if (GameVars.adversaryGoals !== 0) {

                    this.goalsLabel = new Phaser.Text(this.game, goalsLabel_px, 120,
                        "goals: " + GameVars.adversaryGoals + "x " + GameConstants.CREDITS_GOALS + " =",
                        goalsCreditsStyle);

                    this.goalsLabel.visible = false;
                    this.goalsLabel.x -= this.goalsLabel.width;
                    this.add(this.goalsLabel);

                    this.goalsCreditsLabel = new Phaser.Text(this.game, moneyLabel_px, 120,
                        "" +  GameVars.adversaryGoals * GameConstants.CREDITS_GOALS,
                        goalsCreditsStyle);
                    this.goalsCreditsLabel.visible = false;
                    this.goalsCreditsLabel.x -= this.goalsCreditsLabel.width;
                    this.add(this.goalsCreditsLabel);
                }

            } else {

                this.extraGoalsLabel = null;

                this.goalsLabel = new Phaser.Text(this.game, goalsLabel_px, 85,
                    "goals: " + GameVars.playerGoals + "x " + GameConstants.CREDITS_GOALS + " =",
                    goalsCreditsStyle);

                this.goalsLabel.visible = false;
                this.goalsLabel.x -= this.goalsLabel.width;
                this.add(this.goalsLabel);

                this.goalsCreditsLabel = new Phaser.Text(this.game, moneyLabel_px, 85,
                    "" +  GameVars.playerGoals * GameConstants.CREDITS_GOALS,
                    goalsCreditsStyle);
                this.goalsCreditsLabel.visible = false;
                this.goalsCreditsLabel.x -= this.goalsCreditsLabel.width;
                this.add(this.goalsCreditsLabel);
            }
        }

        private addCoins(): void {

            if (GameVars.playerGoals === 0) {
                return;
            }

            let delayBigCoins: number;
            let belowTargetGoals = GameVars.playerGoals - GameVars.adversaryGoals > 0
                ? GameVars.adversaryGoals : GameVars.playerGoals;

            let i: number;

            for ( i = 0; i < belowTargetGoals; i++ ) {
                let smallCoinImage = new Phaser.Image(this.game, 445, -16 - i * 9.5, "texture_atlas_5", "little_coin");
                smallCoinImage.anchor.setTo(.5);
                smallCoinImage.scale.setTo(0);
                this.game.add.tween(smallCoinImage.scale).to({x: 1, y: 1}, 300,  Phaser.Easing.Elastic.Out , true, 1000 + 200 * i)
                .onComplete.add(this.onSmallCoinAdded, this);
                this.add(smallCoinImage);
            }

            delayBigCoins = 1000 + 200 * i + 200;

            const aboveTargetGoals = GameVars.playerGoals - GameVars.adversaryGoals;

            if ( aboveTargetGoals > 0 ) {

                for ( i = 0; i < aboveTargetGoals; i++ ) {
                    const bigCoinImage = new Phaser.Image(this.game, 345, -18 -  i * 15.5, "texture_atlas_5", "big_coin");
                    bigCoinImage.anchor.set(.5);
                    bigCoinImage.scale.set(0);
                    this.game.add.tween(bigCoinImage.scale).to({x: 1, y: 1}, 300,  Phaser.Easing.Elastic.Out , true, delayBigCoins + 200 * i)
                        .onComplete.add(this.onBigCoinAdded, this);
                    this.add(bigCoinImage);
                }
            }
        }

        private onSmallCoinAdded(): void {

            this.credits += GameConstants.CREDITS_GOALS;

            this.creditsLabel.text =  GameVars.formatNumber(this.credits);
            this.creditsLabel.x = GameConstants.GAME_WIDTH / 2 - this.creditsLabel.width / 2;

            MatchResultState.currentInstance.onCoinAdded();
            AudioManager.getInstance().playEffect("moneda");
        }

        private onBigCoinAdded(): void {

            this.credits += GameConstants.CREDITS_EXTRA_GOALS;

            this.creditsLabel.text =  GameVars.formatNumber(this.credits);
            this.creditsLabel.x = GameConstants.GAME_WIDTH / 2 - this.creditsLabel.width / 2;

            MatchResultState.currentInstance.onCoinAdded();

            AudioManager.getInstance().playEffect("moneda");
        }

        private startCreditsAnimation(): void {

            this.game.time.events.add(1000, this.changeBelowLabelVisibility, this);
        }

        private changeBelowLabelVisibility(): void {

            if (this.goalsLabel !== null) {
                this.goalsLabel.visible = true;
                this.goalsCreditsLabel.visible = true;
            }

            if (this.extraGoalsLabel !== null) {
                this.game.time.events.add(1000, this.changeAboveLabelVisibility, this);
            } else {
                this.game.time.events.add(1000, this.updateCreditsLabel, this);
            }
        }

        private changeAboveLabelVisibility(): void {

            this.extraGoalsLabel.visible = true;
            this.extraGoalsCreditsLabel.visible = true;

            this.game.time.events.add(1000, this.updateCreditsLabel, this);
        }

        private updateCreditsLabel(): void {

            GameManager.updateCreditsAfterMatchEnd();

            MatchResultState.currentInstance.showMenuButtons();

            this.rays.visible = true;
            this.game.time.events.add(1250, this.removeRays, this);

            AudioManager.getInstance().playEffect("pick_coins");
        }

        private removeRays(): void {

            this.game.add.tween(this.rays)
                .to({alpha: 0}, 1000,  Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function(): void {
                    this.rays.destroy();
                }, this);
        }
    }
